module.exports = __webpack_public_path__ + "static/media/image-06.82255dd2.png";